<template>
   <div >
     
  
        <div :hidden="hideprofile">
      <div class="grouptwo">
         <div class="sidebyside widthbanner">
            <span style="cursor: pointer;" > <b>&larr; Create Profile</b></span>              
         </div>
         <div class=" rightalign  widthother paragraphname" >
            <button class="button">Create</button>
         </div>
      </div>
      <div>
      
         <div class="navmenu" >
            <nav>
            <div class="profileimagedisplay">
              
     <div class="fileUpload btn btn-primary">
    <!-- <img :src="profileobject.imagefile" id="output"  v-model="profile" width="50" height="50" top="0" right="0" radius="10"  class="profileimage"/>-->
 <input type="file"class="upload"  accept="image/*" name="image"  id="file" @change="loadFile()">  

  

</div></div>
               <ul>
                  <hr>
                  </hr>
                  <li ><a href="#basicinfo" class="vertical">Basic Information</a></li>
                  <hr>
                  </hr>
                  <li><a href="#contactinfo">Contact Details</a></li>
                  <hr>
                  </hr>
                  <li><a href="#section-3">Work Experience</a></li>
                  <hr>
                  </hr>
                  <li><a href="#section-4">Highest Education</a></li>
                  <hr>
                  </hr>
                  <li><a href="#section-5">Current Location</a></li>
                  <hr>
                  </hr>
                  <li><a href="#section-6">Skills</a></li>
                  <hr>
                  </hr>
                    <button>Privacy Settings</button>
               </ul>
             
            </nav>
            
            <div class="main">
               <section id="basicinfo">         
               <h4>Basic Information</h4>
                  <div >
                    <input type="hidden" id="test6" value="no" ng-model="isFull" checked>
                     <input type="checkbox" id="test6" value="yes" ng-model="isFull">
                  &nbsp;&nbsp;I am a Fresher</div>
                
       <!-- <input type="file" id="file" ref="file" accept="image/*" v-on:change="handleFileUpload()"/>
     
      <img v-bind:src="imagePreview" v-show="showPreview"/> -->
                  <div class="form-group">
                     <div class="floating-label col-50">
                        <input v-model="firstname" class="floating-input "  id="floating-input" v-validate=" 'required' " name="First Name" data-vv-as="First Name" type="text"  placeholder=" ">
                        <span class="highlight"></span>
                        <label>First Name*</label>
                        <div v-if="errors.has('First Name')" class="alert-danger">{{ errors.first('First Name') }}</div>
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <input  class="floating-input " v-validate=" 'required' " v-model="lastname" name="Last Name" data-vv-as="Last Name" type="text"  placeholder=" ">
                        <span class="highlight"></span>
                        <label>Last Name*</label>
                        <div v-if="errors.has('Last Name')" class="alert-danger">{{ errors.first('Last Name') }}</div>
                     </div>
                  </div>
                  <div class="form-group">
                     <div class="floating-label col-100">
                        <select  class="floating-select" v-model="gender" v-validate=" 'required' " onclick="this.setAttribute('value', this.value);" value="" name="Gender" data-vv-as="Gender"   placeholder=" ">
                           <option value=""></option>
                           <option value="Male">Male</option>
                           <option value="Female">Female</option>
                        </select>
                        <span class="highlight"></span>
                        <label>Gender*</label>
                        <div v-if="errors.has('Gender')" class="alert-danger">{{ errors.first('Gender') }}</div>
                     </div>
                  </div>
                  <div class="form-group">
                     <div class="floating-label col-50">
                        <input  class="floating-input "  type="text"  v-model="companyname" placeholder=" ">
                        <span class="highlight"></span>
                        <label>Company Name</label>      
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <input  class="floating-input" type="text" v-model="designation" placeholder=" ">
                        <span class="highlight"></span>
                        <label>Designation</label>      
                     </div>
                  </div>
                  <div class=" form-group">      
                     <textarea class="col-60" cols="10" rows="10" v-model="aboutYou" placeholder="About You (Optional) "></textarea>
                     <span class="highlight"></span>
                  </div>
               </section>
               <section id="contactinfo">
                  <h4>Contact Details</h4>
                  <div class="form-group">
                     <div class="floating-label col-100">
                        <input  class="floating-input " v-validate=" 'required' " v-model="email" name="Email" data-vv-as="Email" type="email"  placeholder=" ">
                        <span class="highlight"></span>
                        <label>Email Address*</label>
                        <div v-if="errors.has('Email')" class="alert-danger">{{ errors.first('Email') }}</div>
                     </div>
                  </div>
                  <div class="form-group">
                     <div class="floating-label col-50">
                        <input  class="floating-input " v-model="primaryPhoneNumber" v-validate=" 'required' " name="Mobile Number" data-vv-as="Mobile Number" type="text"  placeholder=" ">
                        <span class="highlight"></span>
                        <label>Primary Mobile Number*</label>
                        <div v-if="errors.has('Mobile Number')" class="alert-danger">{{ errors.first('Mobile Number') }}</div>
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <input  class="floating-input" v-model="alternatePhoneNumber"  type="text"  placeholder=" ">
                        <span class="highlight"></span>
                        <label>Alternative Mobile Number</label>      
                     </div>
                  </div>
                  <div class="form-group">
                     <div class="floating-label col-100">
                        <input  class="floating-input " v-model="websiteUrl" type="text"  placeholder=" ">
                        <span class="highlight"></span>
                        <label>Website / Potfolio URL</label>      
                     </div>
                  </div>
               </section>
               <section id="section-3">
                  <h4>Work Experience</h4>
                    <div v-for="(exep,index) in experience"   v-bind:key="index">
                           <div v-if= "(index >=1 )">                      
                              <button v-on:click="deleteExperience(index)" class="more3">Remove</a>
                              </button> <br><br>      
                           </div>
                  <div class="form-group">
                     <div class="floating-label col-50">
                        <select  class="floating-select"   v-model="experience[index].company" v-validate=" 'required' " onclick="this.setAttribute('value', this.value);" value="" name="Company" data-vv-as="Company"   placeholder=" ">
                           <option value=""></option>
                           <option value="Syntrino">Syntrino</option>
                            <option value="Oracle">Oracle</option>
                        </select>
                        <span class="highlight"></span>
                        <label>Company*</label>
                        <div v-if="errors.has('Company')" class="alert-danger">{{ errors.first('Company') }}</div>
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <select  class="floating-select" v-model="experience[index].jobRole" v-validate=" 'required' " onclick="this.setAttribute('value', this.value);" value="" name="Role" data-vv-as="Role"   placeholder=" ">
                           <option value=""></option>
                           <option value="Java Developer">Java Developer</option>
                            <option value="Phython Developer">phython Developer</option>
                        </select>
                        <span class="highlight"></span>
                        <label>Role*</label>
                        <div v-if="errors.has('Role')" class="alert-danger">{{ errors.first('Role') }}</div>
                     </div>
                  </div>
                  <div class="form-group">
                     <div class="floating-label col-100">
                        <select  class="floating-select"  v-model="experience[index].jobType" v-validate=" 'required' "    onclick="this.setAttribute( this.value);" value=""  name="Type" data-vv-as="Type"   placeholder=" ">
                           <option value=""></option>
                           <option value="FullTime">FullTime</option>
                           <option value="PartTime">PartTime</option>
                           <option value="Freelancer">Freelancer</option>
                        </select>
                        <span class="highlight"></span>
                        <label>Type*</label>
                        <div v-if="errors.has('Type')" class="alert-danger">{{ errors.first('Type') }}</div>
                     </div>
                  </div>
                  <div class="form-group">
                     <div class="floating-label col-50">
                        <input class="floating-input" type="text" v-model="experience[index].startDate" v-validate=" 'required' "  onclick="(this.type='date')" name="Start Date" data-vv-as="Start Date" placeholder=" ">
                        <span class="highlight"></span>
                        <label>Start Date*</label>
                        <div v-if="errors.has('Start Date')" class="alert-danger">{{ errors.first('Start Date') }}</div>
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <input class="floating-input" type="text"  v-model="experience[index].endDate" v-validate=" 'required' "  onclick="(this.type='date')" name="End Date" data-vv-as="End Date" placeholder=" ">
                        <span class="highlight"></span>
                        <label>End Date*</label>
                        <div v-if="errors.has('End Date')" class="alert-danger">{{ errors.first('End Date') }}</div>
                     </div>
                  </div>                 
                  
                      </div>
                      <button v-on:click="addExperience()" class="addform"> Add</button>
                     <!--  <button v-on:click="test()" class="addform"> Add</button> -->
               </section>








               <section id="section-4">
                  <h4>Highest Education</h4>     
                   <div v-for="(certificate,index) in certificates"   v-bind:key="index">
                           <div v-if= "(index >=1 )">                      
                              <button v-on:click="deleteCertification(index)" class="more3">Remove</a>
                              </button><br><br>    
                              </div>           
                  <div class="form-group">
                     <div class="floating-label col-50">
                        <select  class="floating-select" v-model="certificates[index].institutionName" v-validate=" 'required' " onclick="this.setAttribute('value', this.value);" value="" name="Institution Name" data-vv-as="Institution Name"   placeholder=" ">
                           <option value=""></option>
                           <option value="Syntrino">Institution Name</option>
                        </select>
                        <span class="highlight"></span>
                        <label>Institution Name*</label>
                        <div v-if="errors.has('Institution Name')" class="alert-danger">{{ errors.first('Institution Name') }}</div>
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <select  class="floating-select" v-model="certificates[index].typeOfDegree"  v-validate=" 'required' " onclick="this.setAttribute('value', this.value);" value="" name="Type Of Degree" data-vv-as="Type Of Degree"   placeholder=" ">
                           <option value=""></option>
                           <option value="Java Developer">Type Of Degree</option>
                        </select>
                        <span class="highlight"></span>
                        <label>Type Of Degree*</label>
                        <div v-if="errors.has('Type Of Degree')" class="alert-danger">{{ errors.first('Type Of Degree') }}</div>
                     </div>
                  </div>
                  <div class="form-group">
                     <div class="floating-label col-50">
                        <select  class="floating-select" v-model="certificates[index].fieldOfStudy" v-validate=" 'required' " onclick="this.setAttribute('value', this.value);" value="" name="Field Of Study" data-vv-as="Field Of Study"   placeholder=" ">
                           <option value=""></option>
                           <option value="Field Of Study">Field Of Study</option>
                          
                        </select>
                        <span class="highlight"></span>
                        <label>Field Of Study*</label>
                        <div v-if="errors.has('Field Of Study')" class="alert-danger">{{ errors.first('Field Of Study') }}</div>
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <select  class="floating-select" v-model="certificates[index].location" v-validate=" 'required' " onclick="this.setAttribute('value', this.value);" value="" name="Location" data-vv-as="Location"   placeholder=" ">
                         <option value="Hyderabad">Hyderabad</option>
                          
                        </select>
                        <span class="highlight"></span>
                        <label>Location*</label>
                        <div v-if="errors.has('Location')" class="alert-danger">{{ errors.first('Location') }}</div>
                     </div>
                  </div>
                  <div class="form-group">
                     <div class="floating-label col-50">
                        <input class="floating-input" v-model="certificates[index].fromDate" type="text" v-validate=" 'required' "  onclick="(this.type='date')" name="From" data-vv-as="From" placeholder=" ">
                        <span class="highlight"></span>
                        <label>From*</label>
                        <div v-if="errors.has('From')" class="alert-danger">{{ errors.first('From') }}</div>
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <input class="floating-input" v-model="certificates[index].toDate" type="text" v-validate=" 'required' "  onclick="(this.type='date')" name="To" data-vv-as="To" placeholder=" ">
                        <span class="highlight"></span>
                        <label>To*</label>
                        <div v-if="errors.has('To')" class="alert-danger">{{ errors.first('To') }}</div>
                     </div>
                  </div>

                
                       
                           </div>
                  <button v-on:click="addCertification()" class="addform"> Add More Certification</button>
               </section>



               <section id="section-5">
                  <h4>Location</h4>

<div class="form-group">
                     <div class="floating-label col-50">
                        <select  class="floating-select"  v-model="country"  v-validate=" 'required' " onclick="this.setAttribute('value', this.value);" value="" name="Select Country" data-vv-as="Select Country"  @change="getstates()" placeholder=" ">
                           
                           <option v-for="countrydata in countries" v-bind:value="countrydata.value">{{countrydata.key}}</option>
                        </select>
                        <span class="highlight"></span>
                        <label>Select Country*</label>
                        <div v-if="errors.has('Select Country')" class="alert-danger">{{ errors.first('Select Country') }}</div>
                     </div>
                     <div class="floating-label col-50 floatingright" v-if="country=='' || country=='USA'">
                        <select  class="floating-select" v-model="workAuthorization"  v-validate=" 'required' " onclick="this.setAttribute('value', this.value);" value="" name="Work Authorization" data-vv-as="Work Authorization"   placeholder=" ">
                           <option value="Employeement Authorization Document(EAD)">Employeement Authorization Document(EAD)</option>
                              <option value="Green Card">Green Card</option>
                              <option value="H1B">H1B</option>
                              <option value="Us">Us</option>
                              <option value="Us Citizen">Us Citizen</option>
                              <option value="Tn">Tn</option>                      
                        </select>
                        <span class="highlight"></span>
                        <label>Work Authorization*</label>
                        <div v-if="errors.has('Work Authorization')" class="alert-danger">{{ errors.first('Work Authorization') }}</div>
                     </div>
                  </div>

                  <div class="form-group">
                     <div class="floating-label col-50" >
                        <select  class="floating-select" v-validate=" 'required' " v-model="state"  onclick="this.setAttribute('value', this.value);" value="" name="State" data-vv-as="State"   placeholder=" ">
                           <option value=""></option>
                           <option value="State" v-for="data in stateslist">{{data}}</option>
                          
                        </select>
                        <span class="highlight"></span>
                        <label>State*</label>
                        <div v-if="errors.has('State')" class="alert-danger">{{ errors.first('State') }}</div>
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <select  class="floating-select" v-validate=" 'required' " v-model="city" onclick="this.setAttribute('value', this.value);" value="" name="City" data-vv-as="City"   placeholder=" ">
                               <option value="Hyderabad">Hyderabad</option>
                            <option value="Hyderabad">Khammam</option>
                        </select>
                        <span class="highlight"></span>
                        <label>City*</label>
                        <div v-if="errors.has('City')" class="alert-danger">{{ errors.first('City') }}</div>
                     </div>
                  </div>
                  <div class="form-group">
                     <div class="floating-label col-100">
                        <input class="floating-input" type="text" v-validate=" 'required' "  v-model="zipCode" name="ZipCode" data-vv-as="ZipCode" placeholder=" ">
                        <span class="highlight"></span>
                        <label>Zip Code*</label>
                        <div v-if="errors.has('ZipCode')" class="alert-danger">{{ errors.first('ZipCode') }}</div>
                     </div>
                     
                  </div>





               </section>
               <section id="section-6">
                  <h4>Skills</h4>
                  <div >
                  
              <div v-for="(skill,index) in skills"   v-bind:key="index" >
                           <div v-if= "(index >=1 )">                      
                              <button v-on:click="deleteskills(index)" class="more3">Remove</a>
                              </button><br><br>    
                              </div> 
                            <div >                     
     <div class="form-group" >
                     <div class="floating-label col-50">
                        <input class="floating-input" v-model="skills[index].knowledgeIn" type="text"  placeholder="knowledgeIn">
                        <span class="highlight"></span>                                             
                     </div>
                     <div class="floating-label col-50 floatingright">
                        <input class="floating-input" v-model="skills[index].technologyTools" type="text" placeholder="technologyTools">
                        <span class="highlight"></span>                                              
                     </div>
                  </div>
</div></div>
                   <button v-on:click="addSkills()" class="addform"> Add More Skills</button>
</div>



               </section>
                  <center> <button class="button" @click="saveuserprofiledata()">Create</button></center>
               
            </div>
           
         </div>
         
      </div>
      </div>

          
      
   </div>
</template>
<script>
   import menus from '@/components/Menu.vue'
   import Topmenus from '@/components/TopHeader.vue'
   import BottomFooter from '@/components/BottomFooter.vue'   
    import vselect from '@/css/vselect.css'
     import person from '../assets/person.png'
      import httpuserprofile from '@/js/http-userprofile.js'  
      // import util from '../js/common-utils.js'
      //import htttpsearchpeople from "@/js/http-searchpeople.js";
   export default{
        props:['profileobject'],
   components: {
               menus,
               Topmenus,
               BottomFooter,
            
           },
   
   
       data(){
           return{
              countries:[
 {key:"India", value:"1" },
    {key:"USA", value:"2" },
   

              ],
 hiddenworkauth:true,    
 firstname:'',
 lastname:'',
 gender:'',
 companyname:'',
 designation:'',
 aboutYou:'',
 primaryPhoneNumber:'',
alternatePhoneNumber:'',
email:'',
websiteUrl:'',
description:'',
country:1,
workAuthorization:'',
state:'',
city:'',
zipCode:'',
profile:'',
profilePictureName:'',
profileVideoName:'',
fresherOrExperience:'',
workLocationPreference:'',
  file: '',
        showPreview: false,
        imagePreview: '',
stateslist:[],
 experiencelist:[],
        testing:[],
        userdatalist:[],
             profileId: this.$session.get('profileId'), 
           firstname:'',
                 role:[],
              hidecreateprofilehome:'',
              hideeditprofile:true,   
              hideprofile:false,    

               experience: [{                  
              company:'',
            jobRole:'',
            jobType:'',
            startDate:'',
            endDate:'',
            currentWorkingFlag:'',    
              
               }],           
         
     certificates: [{
      institutionName:'',
typeOfDegree:'',
fieldOfStudy:'',
location:'',
fromDate:'',
toDate:'',
currentStudyFlag:'',  
 profileId: this.$session.get('profileId'),     
    }],
skills:[{
knowledgeIn:'',
technologyTools:'',
profileId:this.$session.get('profileId'),
}],
   
       }
       
       },
       methods:{
           fetchdata(){
              this.getstates()
             console.log(this.$session.get('user_id'));
           
   this.sidenav();  
           },

userprofileobject(){
return{
                firstName:this.firstname,
                lastName:this.lastname,
                gender:this.gender, 
                designation:this.designation,    
                aboutYou:this.aboutYou,
                primaryPhoneNumber:this.primaryPhoneNumber, 
                alternatePhoneNumber:this.alternatePhoneNumber,   
                email:this.email,
                websiteUrl:this.websiteUrl,
                description:this.description,
                country:this.country,
                workAuthorization:this.workAuthorization,
                state:this.state,
                city:this.city,
                zipCode:this.zipCode,
                profile:this.profile,              
                fresherOrExperience:'F',
                workLocationPreference:'Y',
               inactiveD: null,
                 userId:this.$session.get('user_id'),
                profileId:this.$session.get('profileId'),
                 creationUserI: this.email,
                   creationD: new Date,
               lastUpdatedUserI: null,
                   lastUpdatedD: null,
                   'workExperience':this.experienceobject(),
                   'userSkill':this.skillsobject(),
                   'userEducation':this.educationObject(),
                 
                   
}

},


 experienceobject: function()
     {
        var explist =[];
       for(var i = 0 ; i< this.experience.length ; i++)

{    
   var reviewobject = this.experience[i]   
          explist.push({
             company:reviewobject.company,
                jobRole:reviewobject.jobRole,
                jobType:reviewobject.jobType,
                startDate:reviewobject.startDate,
                endDate:reviewobject.endDate,
                currentWorkingFlag:'Y',
                "profileId":this.$session.get('profileId'),
            
          });
        }
        return explist;
      },
      skillsobject(){

  var skillist =[];
       for(var i = 0 ; i< this.skills.length ; i++)

{    
   var reviewobjects = this.skills[i]   
          skillist.push({
            knowledgeIn:reviewobjects.knowledgeIn,
            technologyTools:reviewobjects.technologyTools,
            "profileId":this.$session.get('profileId'),
            
          });
        }
        return skillist;

         
      },
      educationObject(){
 var educationlist =[];
       for(var i = 0 ; i< this.certificates.length ; i++)

{    
   var creviewobject = this.certificates[i]   
          educationlist.push({
            "institutionName": creviewobject.institutionName,
            "typeOfDegree": creviewobject.typeOfDegree,
            "fieldOfStudy": creviewobject.fieldOfStudy,
            "location": creviewobject.location,
            "fromDate": creviewobject.fromDate,
            "toDate": creviewobject.toDate,
            "currentStudyFlag": "Y",
            "profileId":this.$session.get('profileId'),
          });
        }
        return educationlist;


      },
      saveuserprofiledata(){

 if (!this.$session.get('profileId')) {
   this.saveuserprofile();
      }
else{
   console.log("update")
   this.updateuserprofile();
   setTimeout(() =>  this.$emit('modifiedProfile', 'All'), 2000);
}
      },

      updateuserprofile(){
         let profileobjects = this.userprofileobject();

            
             
httpuserprofile.put('/userprofile/user/'+ this.profileId , profileobjects,

                
 
          ).then(response => {
       console.log('SUCCESS!!');
   var status = response.data
   

   }).catch(function(){
          console.log('FAILURE!!');
        });

      },
      getprofiledata(index){

httpuserprofile.get('/userprofile/userbyid/' + this.profileId).then(response => {
    
            
   var userdatalist = response.data
   this.email = userdatalist.email
   this.firstname = userdatalist.firstname
   this.lastname=userdatalist.lastname
   this.primaryPhoneNumber = userdatalist.primaryPhoneNumber
   this.alternatePhoneNumber = userdatalist.alternatePhoneNumber
   this.gender = userdatalist.gender
   this.designation = userdatalist.designation
   this.aboutYou = userdatalist.aboutYou
   this.websiteUrl=userdatalist.websiteUrl
   this.description = userdatalist.description
   this.country=userdatalist.country
   this.state=userdatalist.state
   this.city=userdatalist.city
   this.ZipCode=userdatalist.zipCode
   console.log(this.email)
     
 this.skills = userdatalist.userSkill
       this.skills.push({
  knowledgeIn :this.skills.knowledgeIn,
  technologyTools:this.skills.technologyTools 
  
   });      
      
      
      
     this.experience = userdatalist.workExperience
       this.experience.push({
company :this.experience.company,
jobRole:this.experience.jobRole,
jobType:this.experience.jobType,
startDate:this.experience.startDate,
endDate:util.this.experience.endDate,
currentWorkingFlag:this.experience.currentWorkingFlag,
   
  
   });
  
     
    
   this.certificates = this.userdatalist.userEducation
       this.certificates.push({
           institutionName:  this.certificates.institutionName,
            typeOfDegree:  this.certificates.typeOfDegree,
            fieldOfStudy:  this.certificates.fieldOfStudy,
            location:  this.certificates.location,
            fromDate:  this.certificates.startDate,
            toDate:  this.certificates.education.toDate,
            currentStudyFlag:  this.certificates.currentStudyFlag,
  
   });
   
    
})
   },
 saveuserprofile(){
  var bodyFormData = new FormData();
   let profiledata = this.userprofileobject();      
    
     


                     bodyFormData.set('userProfile', profiledata );
                     bodyFormData.append('profilePicture', person); 
           
         
          
         httpuserprofile.post('/userprofile', bodyFormData,
         {
 headers: {'Content-Type': 'multipart/form-data' }
}).then(response => {         

 
          
        
      
   var status = response.data
   
  
   })

  
}, 
// getstates(){
           
           
// htttpsearchpeople.get('/states' , {params:{
//     countryCode:this.country
     
//     } } ).then(response => {        

      
//      this.stateslist = response.data
   
//   console.log(JSON.stringify(status))
//    })

  
//},


handleFileUpload(){
           this.file = this.$refs.file.files[0];

        
        let reader  = new FileReader();

        
        reader.addEventListener("load", function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this), false);

        
        if( this.file ){
          
            reader.readAsDataURL( this.file );
          }
        },
    
changeworkauth(){
if(this.country.selected.value = "USA")
{

   this.hiddenworkauth =false
}
},
        homepage: function () {
         //make a rest call to capture a logout for the user
         this.$session.clear();
      this.$session.destroy()
       
      this.$router.push('/')
            

    },
 openNav() {
  document.getElementById("mySidenav").style.width = "250px";
},

 closeNav() {
  document.getElementById("mySidenav").style.width = "0";
},
                test(index){
for(var i = 0 ; i< this.experience.length ; i++)

{    
   this.experiencelist = this.experience          

   }            
let newContact={                  
           companyname: this.experiencelist[i] .companyname,  
           role: this.experiencelist[i] .role, 
           firstname:this.experiencelist[i] .firstname                                                    
                               
          }    
          console.log(JSON.stringify(newContact))
          
   },
    addgetExperience: function() {   
                    var rownum = 1;
           if (this.getexperience.length>0){
            rownum=this.getexperience.length
           }                    
                       this.getexperience.push({                   
                        'rownumber': rownum++,
                       })
                   }, 
                   
                
                  addExperience: function() {         
                                   
                       this.experience.push({                   
  
                       })
                   },
                   deleteExperience: function(index) {                  
                       this.experience.splice(index,1) 
                       if(index===0)
                      this.addExperience()                  
                   },

                    addCertification: function() {                 
                       this.certificates.push({
                         
      
                       })
                   },
                   deleteCertification: function(index) {                  
                       this.certificates.splice(index,1) 
                       if(index===0)
                      this.addCertification()                  
                   },  
              addSkills() { 
           
             this.skills.push({
                        
      
                       })
                        
                   },
                   deleteskills: function(index) {                  
                       this.skills.splice(index,1) 
                       if(index===0)
                      this.addSkills()                  
                   },  

                    loadFile:function() {                          
                             
      	var image = document.getElementById('file').value;
      
  this.profileobject.imagefile = URL.createObjectURL(event.target.files[0]);
 
   }, 
   enablerecruiter:function(){
      this.recruiterprofile=false   
   },
   
           sidenav(){
              let mainNavLinks = document.querySelectorAll("nav ul li a");
   let lastId;
   let cur = [];
   
   window.addEventListener("scroll", event => {
     let fromTop = window.scrollY;
   
     mainNavLinks.forEach(link => {
       let section = document.querySelector(link.hash);
   
       if (
         section.offsetTop <= fromTop &&
         section.offsetTop + section.offsetHeight > fromTop
       ) {
         link.classList.add("current");
       } else {
         link.classList.remove("current");
       }
     });
   });
   
   
           }
       },
       mounted:function(){
           this.fetchdata()
             this.profileId=this.$session.get('profileId')
             if(this.profileId > 0)
             {

                this.getprofiledata();
             }
           
           console.log("D")
           this.fetchdata();
           
       }
   }

</script>
<style scoped>
   
   /****  floating-Lable style start ****/
  
   label {
   color:black; 
   font-size:12px;
   font-weight:normal;
   position:absolute;
   pointer-events:none;
   left:0px;
   top:5px;
   transition:0.2s ease all; 
   -moz-transition:0.2s ease all; 
   -webkit-transition:0.2s ease all;
   }

   
</style>